import React from 'react';
import { useFormContext } from 'framework/form';

interface ConditionalWrapperProps {
  children: React.ReactElement;
  isVisible: (data: Record<string, unknown>) => boolean;
}

const ConditionalWrapper = ({ children, isVisible }: ConditionalWrapperProps) => {
  const { data: formData = {} } = useFormContext();

  if (!isVisible(formData)) {
    return null;
  }

  return children;
};

export default ConditionalWrapper;
